import { Api } from 'utils';

class ReportService {
  static getHistory = async (params = {}) => Api.createResponse('app/reports/history', params);
  static getPayments = async (params = {}) => Api.createResponse('app/reports/payments', params);
  static getPaymentMethods = async (params = {}) =>
    Api.createResponse('app/reports/payment-methods', params);
  static getPaymentService = async (params = {}) =>
    Api.createResponse('app/reports/payments-service', params);

  static admin = {
    getPayments: async (params?: any) => Api.createResponse('admin/reports/payments', params),
    getMemberships: async (params?: any) => Api.createResponse('admin/reports/memberships', params),
    getHistory: async (params?: any) => Api.createResponse('admin/reports/history', params),
    downloadPayments: async (params?: any) =>
      Api.createResponse('admin/reports/download-payments', params),
    getComissions: async (params?: any) => Api.createResponse('admin/reports/comissions', params),
    getServicesPayments: async (params?: any) =>
      Api.createResponse('admin/reports/service-payments', params),
    getPackagePayments: async (params?: any) =>
      Api.createResponse('admin/reports/package-payments', params),
    downloadPackagePayments: async (params?: any) =>
      Api.createResponse('admin/reports/download-package-payments', params),
  };
}

export default ReportService;
